/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { getHandler, stdErrHandlerFactory } from "../../utils/Requests";
import { AnyAction, Dispatch } from "@reduxjs/toolkit";
import { Company, CompanyDetailsResponse, ServiceLocation, Setter } from "../../utils/Interfaces";
import { AxiosResponse } from "axios";

export function updateCompany(
    companyId: number,
    dispatch: Dispatch<AnyAction>,
    setCompany: Setter<Company>,
    setSites: Setter<ServiceLocation[]>,
    setLoading: Setter<boolean>
) {
    getHandler<CompanyDetailsResponse>(
        `/api/companies/details/${companyId}`,
        dispatch,
        (response: AxiosResponse<CompanyDetailsResponse, any>) => {
            setCompany(response.data.company);
            setSites(response.data.sites);
        },
        stdErrHandlerFactory(dispatch),
        setLoading
    );
}
